import { useCallback, useEffect } from 'react';
import Page from '../../../../components/page/Page';
import Header from '../../../../components/administration/masters/formats/Header';
import { IconButton, Paper } from '@mui/material';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import useThemeMediaQuery from '../../../../../core/hooks/useThemeMediaQuery';
import { useNavigationCore } from '../../../../../core/router/navigation';
import { useMeCore } from '../../../../../core/modules/me';
import { useGlobalCore } from '../../../../../core/modules/global';
import CreateDialog from '../../../../components/administration/masters/formats/CreateDialog';
import UpdateDialog from '../../../../components/administration/masters/formats/UpdateDialog';
import { useMasterCore } from '../../../../../core/modules/master';
import { useCompanyCore } from '../../../../../core/modules/company';
import EditIcon from '@mui/icons-material/Edit';
import { UPDATE_FORMAT_DIALOG } from '../../../../../core/constants/dialog';
import { Format } from '../../../../../core/interfaces/format.interface';

const Formats = () => {
  const { user } = useMeCore();
  const { openDialog } = useGlobalCore();
  const { companyId } = useCompanyCore();
  const { formats, setFormat, getFormats, clearError } = useMasterCore();
  const { goToWelcome } = useNavigationCore();

  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));

  useEffect(() => {
    if (
      !user ||
      (
        !user.privileges.superAdmin &&
        !user.privileges.writeMaster
      )
    ) {
      goToWelcome();
    }
  }, [user, goToWelcome]);

  useEffect(() => {
    if (companyId) {
      getFormats(companyId);
    }
  }, [companyId, getFormats]);

  const selectFormat = useCallback((format: Format) => {
    setFormat(format);
    clearError();
    openDialog(UPDATE_FORMAT_DIALOG);
  }, [clearError, openDialog, setFormat]);

  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: 'Nombre',
      flex: 1,
    },
    {
      field: 'actions',
      headerName: '',
      cellClassName: 'text-end',
      renderCell: (params: GridRenderCellParams) => (
        <IconButton aria-label="edit" onClick={() => selectFormat(params.row)}>
          <EditIcon />
        </IconButton>
      )
    },
  ];

  return (
    <>
      <Page
        header={<Header />}
        content={
          <div className="w-full my-16 px-24 md:px-32">
            <Paper className="flex flex-col flex-auto items-center shadow rounded-2xl overflow-hidden">
              <div className="w-full p-32">
                <DataGrid
                  rows={formats}
                  columns={columns}
                  sx={{ border: 0 }}
                  disableColumnSorting
                  disableColumnFilter
                  disableRowSelectionOnClick
                  disableMultipleRowSelection
                  hideFooter
                  pagination={undefined}
                />
              </div>
            </Paper>
          </div>
        }
        scroll={isMobile ? 'normal' : 'content'}
      />
      <CreateDialog />
      <UpdateDialog />
    </>
  );
};

export default Formats;
